/*
 *   Copyright (c) 2020 
 *   All rights reserved.
 */
import $ from "jquery"


class DonateNow {
    constructor() {
        this.init();
    }

    init() {
        const $exist = $('.clf2020-donate-now-form').length > 0;

        if (!$exist) return;

        const $button = $(`
                        <button class="btn-donate-paypal" type="submit">
                            <img src="/wp-content/themes/clf-theme/fe-src/assets/images/structure/paypal.svg"alt="paypal"/>
                        </button>
        `);
        const $paypalShortCodeContainer = $('.paypal-shortcode-container');

        const intervalExist = setInterval(() => {
            const $form = $paypalShortCodeContainer.find('form');
            if ($form.length > 0) {
                $form.find('input[name="submit"]').remove();
                $form.append($button);
                clearInterval(intervalExist);
            }
        }, 100);
    }
}

export default DonateNow;